export default function PricingCard({ title, price, description }: { title: string, price: string, description: string }) {
    return (
        <div className="flex flex-col items-center justify-center px-10 py-8 bg-gray-800 rounded-xl shadow-lg">
            <h3 className="font-bold text-2xl mb-2">{title}</h3>
            <p className="text-5xl font-bold text-green-700">{price}</p>
            <p className="text-lg">{description}</p>
        </div>
    );
}